import React, { forwardRef } from 'react';
import { color, space, font, radius } from './tokens';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid = false, style, rows = 4, disabled, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid || undefined}
      disabled={disabled}
      style={{
        display:      'block',
        width:        '100%',
        padding:      `${space[2]}px ${space[3]}px`,
        fontSize:     font.size.base,
        fontFamily:   font.family.sans,
        lineHeight:   1.5,
        background:   disabled ? color.bg.subtle : color.bg.card,
        color:        color.text.primary,
        border:       `1px solid ${invalid ? color.status.error.border : color.border.strong}`,
        borderRadius: radius.md,
        outline:      'none',
        resize:       'vertical',
        ...style,
      }}
      {...rest}
    />
  );
});

export default Textarea;
